module.exports = __webpack_public_path__ + "static/media/Cafe del Mar (bel).c27f250d.mp3";